import {
    SETTINGS_ANNOUNCEMENT_GET_ALL,
    SETTINGS_ANNOUNCEMENT_ADDNEW,
    SETTINGS_ANNOUNCEMENT_UPDATE,
    SETTINGS_ANNOUNCEMENT_DELETE,
    SETTINGS_PAYMENT_BESOFT_UPDATE,
    SETTINGS_GET_ALL
} from "../actions/settings";

import {
    API_BASE_URL,
    SETTINGS_ANNOUNCEMENT_GET_ALL_URL,
    SETTINGS_ANNOUNCEMENT_ADDNEW_URL,
    SETTINGS_ANNOUNCEMENT_UPDATE_URL,
    SETTINGS_ANNOUNCEMENT_DELETE_URL,
    SETTINGS_PAYMENT_BESOFT_UPDATE_URL,
    SETTINGS_GET_ALL_URL
} from "../variables";

import axios from "axios";

const state = {};
const mutations = {};
const getters = {};
const actions = {
    [SETTINGS_GET_ALL]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SETTINGS_GET_ALL_URL,
            method: "GET",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [SETTINGS_PAYMENT_BESOFT_UPDATE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SETTINGS_PAYMENT_BESOFT_UPDATE_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [SETTINGS_ANNOUNCEMENT_GET_ALL]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SETTINGS_ANNOUNCEMENT_GET_ALL_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [SETTINGS_ANNOUNCEMENT_ADDNEW]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SETTINGS_ANNOUNCEMENT_ADDNEW_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [SETTINGS_ANNOUNCEMENT_UPDATE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SETTINGS_ANNOUNCEMENT_UPDATE_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [SETTINGS_ANNOUNCEMENT_DELETE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + SETTINGS_ANNOUNCEMENT_DELETE_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
};


export default {
    mutations,
    actions,
    getters,
    state
};